<template>
    <div>
        <h2 class="text-muted">Sprint</h2>

        <div class=" d-flex justify-content-center align-items-center">
            <BurndownChart class="col-12 col-md-9" type="equipo" name="equipo" title="" :legends="true" width=75
                           color="#40D5E2"></BurndownChart>
        </div>

        <div class=" d-flex justify-content-around flex-wrap">
            <BurndownChart v-for="proj in projects" class="col-12 col-md-3" type="project" :name="proj.key" :title="proj.prettyName"></BurndownChart>
        </div>
        <div class=" d-flex justify-content-around flex-wrap">
            <BurndownChart v-for="dev in devs" class="ml-1 mr-1  col-12 col-md-3" type="developer" :name="dev.key" :title="dev.prettyName"></BurndownChart>
        </div>
    </div>
</template>

<script>
    import BurndownChart from "../components/BurndownChart";
    import Axios from "../utils/http/Axios";

    export default {
        name: "sprintStatus",
        components: {BurndownChart},
        data: _=> {
            return {
                devs: [],
                projects: []
            }
        },
        mounted() {
            this.initProjects();
            this.initDevs();
        },
        methods: {
            initProjects(){
                this.projects = [
                    {
                        key: "debQ",
                        prettyName: "debQ"
                    },
                    {
                        key: "Appointments",
                        prettyName: "Citas"
                    },
                    {
                        key: "Mobile",
                        prettyName: "Mobile"
                    },
                    {
                        key: "Surveys",
                        prettyName: "Encuestas"
                    }
                ]
            },
            initDevs(){
                Axios.getInstance().get('api/getDevs').then(response => {
                    this.devs = response.data;
                }).catch(err => {
                    console.error("Error al obtener devs", err);
                });
            }
        }
    }
</script>

<style scoped>

</style>
